export { NotEcommerceView } from './NotEcommerceView';
